import { from } from '@apollo/client';

import { analyticsLink } from './analyticsLink';
import { authLink } from './authLink';
import { debounceLink } from './debounceLink';
import { errorLink } from './errorLink';
import { httpLink } from './httpLink';
import { serializingLink } from './serializeLink';
import { toastLink } from './toastLink';

export const link = from([errorLink, authLink, analyticsLink, debounceLink, serializingLink, toastLink, httpLink]);
